import React from "react";
import PropTypes from "prop-types";
import { Button, ModalFooter } from "reactstrap";

const propTypes = {
  likesCount: PropTypes.number.isRequired,
  commentsCount: PropTypes.number.isRequired,
  onContinue: PropTypes.func.isRequired,
  onKeep: PropTypes.func.isRequired
};

const FbReviewStep = ({ likesCount, commentsCount, onContinue, onKeep }) => {
  const parts = [];
  if (likesCount > 0)
    parts.push(`${likesCount.toLocaleString()} like${likesCount !== 1 ? "s" : ""}`);
  if (commentsCount > 0)
    parts.push(`${commentsCount.toLocaleString()} comment${commentsCount !== 1 ? "s" : ""}`);
  const label = parts.join(" and ") || "Facebook engagement";

  return (
    <div>
      <p className="text-center text-muted mb-3">
        Are you sure you want to delete the {label} on your Facebook ad?
      </p>

      <div className="notifications warning mb-3">
        <div className="notifications__error-message">
          If this ad is deleted, {label} cannot be recovered.
        </div>
      </div>

      <ModalFooter className="pt-2 px-0">
        <Button color="secondary" className="btn-sharp" onClick={onKeep}>
          Back to my ad
        </Button>
        <Button color="primary" className="btn-sharp" onClick={onContinue}>
          Yes, continue
        </Button>
      </ModalFooter>
    </div>
  );
};

FbReviewStep.propTypes = propTypes;

export default FbReviewStep;
